import styles from "./AddonPopup.module.scss";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef } from "react";
import { Form, FormInstance } from "antd";
import { useNavigate } from "react-router-dom";
import { openSuccessMessage } from "../../../../store/message/messageSlice";
import FormItemInputNumber from "../../../../components/ui/FormItemInputNumber/FormItemInputNumber";
import euroSvg from "../../../../assets/images/icons/euro.svg";
import CustomButton from "../../../../components/ui/CustomButton/CustomButton";
import { IAddon } from "../../../../models/Addon";
import { AddonService } from "../../../../services/addon.service";
import { handleError } from "../../../../helper/errorHandler";
import { useAddonMutations } from "../../../../api/mutations";

interface IAddonPopupProps {
  setShowCreatePopup: (value: boolean) => void;
  item: IAddon | null;
}

const AddonPopup: React.FC<IAddonPopupProps> = ({ item, setShowCreatePopup }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const formRef = useRef<FormInstance>(null);
  const navigate = useNavigate();

  const { createAddon, updateAddon } = useAddonMutations();

  useEffect(() => {
    if (formRef.current && item) {
      formRef.current.setFieldsValue({
        price: item.price,
        credits: item.credits,
      });
    }
  }, [item, formRef.current]);

  const onFinish = async (values: Omit<IAddon, "id">) => {
    const model: Omit<IAddon, "id"> = {
      ...values,
    };

    if (item) {
      updateAddon(
        { id: item.id, model },
        {
          onSuccess: () => {
            dispatch(openSuccessMessage(t("AddonUpdatedSuccessfully")));
            setShowCreatePopup(false);
            redirect();
          },
          onError: (e) => handleError(e, dispatch, t),
        }
      );
    } else {
      createAddon(model, {
        onSuccess: () => {
          dispatch(openSuccessMessage(t("AddonCreatedSuccessfully")));
          setShowCreatePopup(false);
          redirect();
        },
        onError: (e) => handleError(e, dispatch, t),
      });
    }
  };

  const redirect = () => {
    navigate(`/subscriptions/?shouldUpdateAddons=${true}`);
  };

  const clickOnClose = () => {
    setShowCreatePopup(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        <h3 className={styles.title}>{t("AddNewAddon")}</h3>
        <Form
          className={styles.form}
          ref={formRef}
          name="create-addon"
          onFinish={onFinish}
          autoComplete="off"
          layout={"vertical"}
        >
          <div className={styles.row}>
            <FormItemInputNumber
              name={"credits"}
              label={t("NumberOfCredits") + " *"}
              rules={{ required: true }}
            />
            <FormItemInputNumber
              prefix={euroSvg}
              name={"price"}
              label={t("Price") + " *"}
              rules={{ required: true }}
            />
          </div>

          <div className={styles.btnsWrapper}>
            <CustomButton
              text={t("Close")}
              type={"button"}
              typeStyle={"outline"}
              functionOnClick={clickOnClose}
            />
            <CustomButton text={t("Save")} type={"submit"} typeStyle={"fill"} />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddonPopup;
